import axios from "axios";
import { toast } from "react-toastify";

const url = window.location.origin;
switch (url) {
    case "https://royan.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer emFyaWY6WmFyaWZAMTIzNDU2";//zarif
        axios.defaults.headers.get["Authorization"] = "Bearer emFyaWY6WmFyaWZAMTIzNDU2";//zarif
        break;
    case "https://marjan.ariisco.com":
       axios.defaults.headers.post["Authorization"] = "Bearer bWFyamFuOk1hcmphbkAxMjM0NTY=";//marjan
       axios.defaults.headers.get["Authorization"] = "Bearer bWFyamFuOk1hcmphbkAxMjM0NTY=";//marjan
        break
    case "https://rokaceram.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer Um9rZWNlcmFtOlJva2VjZXJhbV83ODkhQ";//rokaceram
        axios.defaults.headers.get["Authorization"] = "Bearer Um9rZWNlcmFtOlJva2VjZXJhbV83ODkhQ";//rokaceram
        break;
    case "https://takceram.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer dGFrY2VyYW06VGFrY2VyYW1AMTIzNDU2";//takceram
        axios.defaults.headers.get["Authorization"] = "Bearer dGFrY2VyYW06VGFrY2VyYW1AMTIzNDU2";//takceram
        break;
    case "https://aref.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer YXJlZjpAQXJlZjEyMzQ1Ng==";//aref
        axios.defaults.headers.get["Authorization"] = "Bearer YXJlZjpAQXJlZjEyMzQ1Ng==";//aref
        break;
    case "https://angeloceramica.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer Vgkk2aW5l0cakioZUAxMjM0N";//angeloceramica
        axios.defaults.headers.get["Authorization"] = "Bearer Vgkk2aW5l0cakioZUAxMjM0N";//angeloceramica
        break;
    case "https://demo1.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer BFGB345HH5hbw2TTY55omkKJJ1";//demo1
        axios.defaults.headers.get["Authorization"] = "Bearer BFGB345HH5hbw2TTY55omkKJJ1";//demo1
        break;
    case "https://demo2.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer jkmc9f7nMI7cInn889R4rtdae2";//demo2
        axios.defaults.headers.get["Authorization"] = "Bearer jkmc9f7nMI7cInn889R4rtdae2";//demo2
        break;
    case "https://demo3.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer ck3BB5gg3gGh55nGxasDDff2r3";//demo3
        axios.defaults.headers.get["Authorization"] = "Bearer ck3BB5gg3gGh55nGxasDDff2r3";//demo3
        break;
    case "https://demo4.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer cmklCC3rfFg445CASdfgG344g4";//demo4
        axios.defaults.headers.get["Authorization"] = "Bearer cmklCC3rfFg445CASdfgG344g4";//demo4
        break;
    case "https://demo5.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer sadk567hHna3rvvfdbgbHHedf5";//demo5
        axios.defaults.headers.get["Authorization"] = "Bearer sadk567hHna3rvvfdbgbHHedf5";//demo5
        break;
    case "https://aratile.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer ZGVjb2Vhc2U6RGVjb2Vhc2VAMTIzfsh1";//aratile
        axios.defaults.headers.get["Authorization"] = "Bearer ZGVjb2Vhc2U6RGVjb2Vhc2VAMTIzfsh1";//aratile
        break;
    case "https://doroudian.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer ZGVjb3sxfc2U6RGVjb2Vhc2VAMTIzfsh1";//doroudian
        axios.defaults.headers.get["Authorization"] = "Bearer ZGVjb3sxfc2U6RGVjb2Vhc2VAMTIzfsh1";//doroudian
        break;

    case "https://poshin.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer ZGVjb3sxfc2U6RGVjb2Vhc2VAMTsghy6g";//poshin
        axios.defaults.headers.get["Authorization"] = "Bearer ZGVjb3sxfc2U6RGVjb2Vhc2VAMTsghy6g";//poshin
    break;
    default:
       axios.defaults.headers.post["Authorization"] = "Bearer ka324324adfaf32rr324324afaaq3rq4";//
       axios.defaults.headers.get["Authorization"] = "Bearer ka324324adfaf32rr324324afaaq3rq4";//
        break;
}


axios.interceptors.response.use(null,error => {
    const exeptedError = error.response && error.response.status >= 400 && error.response.status < 500;
    if(!exeptedError){
        toast.error("مشکلی در سمت سرور رخ داده است!",{
            position:"bottom-right",
            autoClose:1500,
            closeButton:true,
            closeOnClick:true
        });
    };
    return Promise.reject(error);
});

export default {
    post:axios.post,
    get:axios.get,
    put:axios.put,
    delete:axios.delete
};